import Vue from 'vue'
import BinnacleTransformer from './../../transformers/sinister/binnacle'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

const fetchBinnacle = (affectedId) => {

  return Vue.$http.get(`sinisters/affected/${affectedId}/extranet_binnacle/`)
    .then(({ data }) => {
      const transformedResp = BinnacleTransformer.fetchCollection(data);
      return transformedResp;
    })
    .catch((err) => { throw err })
}

export default fetchBinnacle


// WEBPACK FOOTER //
// ./src/services/extranet/fetchBinnacle.js